import * as React from "react";
import type { SVGProps } from "react";
const SvgIconFlowChartActionFill = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M0 6h24v12H0z" /></svg>;
export default SvgIconFlowChartActionFill;